import '../tailwind.css';
import '../scss/main.scss';

import '@glidejs/glide/dist/css/glide.core.min.css';
import '@glidejs/glide/dist/glide.min.js';




import '../js/animations.js';
import '../js/offc-menu.js';
import '../js/navigation.js';


import lightGallery from 'lightgallery';

// Plugin opzionali
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';

// CSS (puoi anche spostarli nel tuo SCSS se preferisci)
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-thumbnail.css';
import 'lightgallery/css/lg-zoom.css';

// Inizializzazione
const galleries = document.querySelectorAll('[id^="gallery_"]');
galleries.forEach(gallery => {
    lightGallery(gallery, {
        selector: '.item',
        plugins: [lgThumbnail, lgZoom],
        speed: 500,
    });
});






function smoothScroll() {
    // Seleziona tutti i link che iniziano con #
    const anchors = document.querySelectorAll('a[href^="#"]');

    anchors.forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();

            const targetElement = document.querySelector(this.getAttribute('href'));
            
            if (targetElement) {
                targetElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start', // Allinea la parte superiore dell'elemento in cima alla viewport
                });
            } else {
                console.error('Elemento non trovato per:', this.getAttribute('href'));
            }
        });

    });
}
// smoothScroll();


/* 
 * Navbar
 */




function offCanvas(){
    const triggers = document.querySelectorAll(".js--offCanvas");
    triggers.forEach( trigger => {
        trigger.addEventListener('click', (e) => {
            const target = e.currentTarget;
            const data = target.getAttribute("data-target");
            const canvas = document.getElementById(data);

            if (canvas.classList.contains('translate-x-full')) {
                canvas.classList.remove('translate-x-full');
                canvas.classList.add('translate-x-0');
            } else if(canvas.classList.contains('translate-x-0')){
                canvas.classList.add('translate-x-0');
                canvas.classList.remove('translate-x-full');
            }
            
            console.log(canvas);
        })
    });
}
offCanvas();



function accordion(){
    document.querySelectorAll('.hst-accordion-header').forEach(item => {
        item.addEventListener('click', (e) => {
            const accordion = item.closest('[data-accordion]');
            const target = document.querySelector(item.getAttribute('data-target'));
            const allBodies = accordion.querySelectorAll('.hst-accordion-body');

            // Chiudi tutte le altre sezioni nell'accordion
            // allBodies.forEach(otherBody => {
            //     if (otherBody !== target) {
            //         otherBody.style.maxHeight = 0;
            //     }
            // });

            // Controlla l'altezza della sezione cliccata
            if (target.style.maxHeight && target.style.maxHeight !== '0px') {
                target.style.maxHeight = 0; // chiudi la sezione
            } else {
                target.style.maxHeight = target.scrollHeight + "px"; // apri la sezione
            }

            e.currentTarget.parentElement.classList.toggle('open');
        });
    });
}
accordion();


function tabs(){
    document.addEventListener("DOMContentLoaded", function () {
        const tabs = document.querySelectorAll('[data-tab-target]');  // Seleziona tutte le tab
        const tabContents = document.querySelectorAll('.tab-content');  // Seleziona tutti i contenuti delle tab
      
        // Funzione per attivare una tab
        function switchTab(targetId) {
          // Rimuovi la classe 'active' da tutte le tab e dai contenuti
          tabs.forEach(tab => tab.classList.remove('active'));
          tabContents.forEach(content => content.classList.remove('active'));
          
          // Aggiungi la classe 'active' alla tab e al contenuto selezionato
          const targetTab = document.querySelector(`[data-tab-target="${targetId}"]`);
          const targetContent = document.getElementById(targetId);
          
          if (targetTab && targetContent) {
            targetTab.classList.add('active');
            targetContent.classList.add('active');
          }
        }
      
        // Gestisci il click sulle tab
        tabs.forEach(tab => {
          tab.addEventListener('click', function (e) {
            const targetId = e.currentTarget.getAttribute('data-tab-target');
            switchTab(targetId);
          });
        });
      
        // Imposta la prima tab come attiva al caricamento della pagina
        if (tabs.length > 0) {
          switchTab(tabs[0].getAttribute('data-tab-target'));
        }
    });      
}
tabs();






window.addEventListener('DOMContentLoaded', function() {

    const fixedDiv = document.querySelector('.fixed-header-gap');
    const gap = document.getElementById('fixed_header_gap');

    if (fixedDiv && gap) {
        const headerHeight = fixedDiv.offsetHeight;
        gap.style.marginTop = `${headerHeight}px`;
    }
});




document.addEventListener('DOMContentLoaded', () => {

    const sliderLinee = document.querySelector(".glide.glide--linee");

    if (!sliderLinee) return;

    new Glide(sliderLinee,{
        type: 'slider',
        perView: 3,
        rewind: false,
        gap: 32,
        breakpoints: {
            576: {
                perView: 1
            },
            991: {
                perView: 2
            }
        }
    }).mount()

});



function tw_collapse_el() {
    const triggers = document.querySelectorAll('[data-collapse]');

    triggers.forEach(trigger => {

        const originalText = trigger.innerText;

        trigger.addEventListener('click', function (event) {
            event.preventDefault(); 

            const targetSelector = this.getAttribute('data-collapse');
            const target = document.querySelector(targetSelector);

            if (!target) return;

            const isExpanded = this.getAttribute('aria-expanded') === 'true';

            this.setAttribute('aria-expanded', !isExpanded);

            target.setAttribute('aria-hidden', isExpanded);

            target.classList.toggle('hidden');
            target.classList.toggle('opacity-0');

            if (!isExpanded) {
                target.focus({ preventScroll: true });
            }

            // Aggiorno il testo del trigger
            if (!isExpanded) {
                trigger.innerHTML = `
                    Close 
                    <svg xmlns="http://www.w3.org/2000/svg" 
                         class="inline-block w-4 h-4 ml-1" 
                         fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                              d="M6 18L18 6M6 6l12 12" />
                    </svg>
                `;
            } else {
                trigger.innerText = originalText;
            }
            
        });
    });
}

document.addEventListener('DOMContentLoaded', tw_collapse_el);





function opc_job_career() {

  const jobArticles = document.querySelectorAll(".single-job-position");

  const jobTitles = Array.from(jobArticles).map(article => {
    const titleEl = article.querySelector(".opc-job-title");
    return titleEl ? titleEl.textContent.trim() : null;
  })


  const form = document.querySelector("form");
  const select = form ? form.querySelector(".options-opc-careers") : null;

  if (select && jobTitles.length > 0) {
    // Rimuovi le opzioni esistenti (opzionale)
    select.innerHTML = '<option value="">Select a job position</option>';

    jobTitles.forEach(title => {
      const option = document.createElement("option");
      option.value = title;
      option.textContent = title;
      select.appendChild(option);
    });
  }


  const applyButtons = document.querySelectorAll(".single-job-apply");

  applyButtons.forEach(button => {
    button.addEventListener("click", function (e) {
      e.preventDefault();

      const article = button.closest(".single-job-position");
      const titleEl = article ? article.querySelector(".opc-job-title") : null;
      const jobTitle = titleEl ? titleEl.textContent.trim() : null;

      if (jobTitle && select) {
        select.value = jobTitle;
        form.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    });
  });
}
document.addEventListener("DOMContentLoaded", opc_job_career());
